export default __webpack_public_path__ + "atomic/_patterns/02-molecules/cookie-compliance/_cookie-compliance.twig";